import { useEffect, useState } from 'react'
import { setMobileGridCount, setTabletGridCount } from 'utils/helpers'

type CurrentCardProps = {
  clientWidth: number
  cardsInRow: number
  rowDirection: string
  tvChannelCard: boolean
}

export const useCurrentCard = ({
  clientWidth,
  cardsInRow,
  rowDirection,
  tvChannelCard,
}: CurrentCardProps): number => {
  const [currentCard, setCurrentCard] = useState(0)

  useEffect(() => {
    if (clientWidth) {
      if (clientWidth < 600) {
        setMobileGridCount({
          clientWidth,
          cardsInRow,
          rowDirection,
          setVisibleCards: setCurrentCard,
          tvChannelCard,
        })
      }
      if (clientWidth >= 600 && clientWidth < 1240) {
        setTabletGridCount({
          clientWidth,
          cardsInRow,
          rowDirection,
          setVisibleCards: setCurrentCard,
          tvChannelCard,
        })
      }
      if (clientWidth >= 1240 && clientWidth < 1640) {
        setCurrentCard(cardsInRow)
      }

      if (clientWidth >= 1640) {
        setCurrentCard(cardsInRow + 1)
      }
    }
  }, [clientWidth, cardsInRow, rowDirection])

  return currentCard
}
